import React, { useState } from "react";

// import JS files

const ProducersShowModal = (props) => {
  let windowWidth = window.screen.width;
  return (
    <>
    <p className="text-center font-bold text-myblue-100 mb-4">لیست تولیدکنندگان این النگو</p>
      <div>{props.selectedItem?.provider.map((item , index)=> {
          return <>
          <></>
               <p className="mt-2">{item.name}</p>
          </>
      })}</div>
    </>
  );
};

export default ProducersShowModal;
